import axios from "axios";

const API = (process.env.REACT_APP_BACKEND_URL || "") + "/api";

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("studioops_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // Phase 25 — attach active outlet header so backend can scope queries
  try {
    const outletId = localStorage.getItem("studioops_active_outlet");
    if (outletId && !config.headers["X-Outlet-Id"]) {
      config.headers["X-Outlet-Id"] = outletId;
    }
  } catch (e) { /* ignore */ }
  return config;
});

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Etwas ist schiefgelaufen.";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (d && typeof d.msg === "string") return d.msg;
  return String(d);
}

export default api;
export { API };
